import * as React from 'react';
import dragula from 'react-dragula';

import randomstring from 'uuid/v4';

import Field from './Field';
import Add from './AddField';
import ButtonAdd from './ButtonAdd';

import { types } from '../../../../const/types.task';

let scrollable = true;
let listener = function(e) {
    if (!scrollable) {
        e.preventDefault();
    }
};

function findElements(elements, codigo, campo) {
    let i;
    let result = [];
    for (i = 0; result.length === 0 && i < elements.length; i++) {
        if (elements[i].filtro === codigo && elements[i][campo]) {
            result.push(elements[i]);
        }
        if (result.length === 0 && elements[i].hijos)
            result = findElements(elements[i].hijos, codigo, campo);
    }
    return result;
}

function searchTree(elements, codigo) {
    let i;
    let result = null;
    for (i = 0; result === null && i < elements.length; i++) {
        if (elements[i].codigo === codigo) {
            result = elements[i];
        }
        if (result === null && elements[i].hijos) result = searchTree(elements[i].hijos, codigo);
    }
    return result;
}

function changeCode(element, parent) {
    element.padre = parent;
    element.codigo = randomstring();
    element.nuevo = 'SI';
    if (element.hijos && element.hijos.length > 0) {
        element.hijos = element.hijos.map((e) => {
            return changeCode(e, element.codigo);
        });
    }
    return element;
}

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    if (startIndex < endIndex) endIndex = endIndex - 1;
    result.splice(endIndex, 0, removed);
    return result;
};

class Fields extends React.Component {
    state = {
        data: this.props.data,
        pending_changes: false,
        show: true,
        open: false,
        type: '',
        parent: undefined,
        form: this.props.form,
    };

    UNSAFE_componentWillMount() {
        document.addEventListener('touchmove', listener, { passive: false });

        this.drake = dragula([document.querySelector('.container')], {
            moves: function(el, container, handle) {
                return handle.classList.contains('draggable');
            },
        });
        this.drake.on('drop', this.drop.bind(this));
        this.drake.on('drag', function(el, source) {
            scrollable = false;
        });
        this.drake.on('dragend', function(el, source) {
            scrollable = true;
        });

        this.drake = dragula([].slice.apply(document.querySelectorAll('.bloc')), {
            direction: 'horizontal',
        });
        this.drake.on('drop', this.drop.bind(this));
        this.drake.on('drag', function(el, source) {
            scrollable = false;
        });
        this.drake.on('dragend', function(el, source) {
            scrollable = true;
        });
    }

    componentDidUpdate() {
        this.drake.containers = [].slice.apply(document.querySelectorAll('.bloc'));
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { form, data } = this.state;
        if (form !== nextProps.form || data !== nextProps.data) {
            this.setState({
                pending_changes: false,
                form: nextProps.form,
                data: nextProps.data,
                openTab: false,
                openField: false,
                openSection: false,
            });
        }
    }

    drop = (el, target, source, sibling) => {
        scrollable = true;
        this.drake.cancel(true);
        try {
            if (target && el && el.id === target.id) {
                console.error('drag&drop ignored');
            } else if (target.id === 'root' && source.id !== 'root') {
                console.error('drag&drop ignored');
            } else if (target.id === 'root') {
                let arr = [...this.state.data];
                const codes = arr.map((f) => f.codigo);
                const source = codes.indexOf(el.id);
                const destination = sibling === null ? arr.length : codes.indexOf(sibling.id);
                arr = reorder(arr, source, destination);
                this.props.onModification(arr);
                this.setState({ data: arr, pending_changes: true });
            } else if (target.id === source.id) {
                const arr = [...this.state.data];
                let list = searchTree(arr, target.id);
                if (list) {
                    const codes = list.hijos.map((f) => f.codigo);
                    const source = codes.indexOf(el.id);
                    const destination =
                        sibling === null ? list.hijos.length : codes.indexOf(sibling.id);
                    list.hijos = reorder(list.hijos, source, destination);
                    this.props.onModification(arr);
                    this.setState({ data: arr, pending_changes: true });
                }
            } else {
                const arr = [...this.state.data];
                let origen = searchTree(arr, source.id);
                if (origen) {
                    let destination = searchTree(arr, target.id);
                    if (destination) {
                        var selected = searchTree(arr, el.id);
                        if (selected && selected.tipo !== destination.tipo) {
                            const sourceIndex = origen.hijos.map((f) => f.codigo).indexOf(el.id);
                            const [removed] = origen.hijos.splice(sourceIndex, 1);
                            const destinationIndex =
                                sibling === null
                                    ? destination.hijos.length
                                    : destination.hijos.map((f) => f.codigo).indexOf(sibling.id);
                            removed.padre = target.id;
                            destination.hijos.splice(destinationIndex, 0, removed);
                            this.props.onModification(arr);
                            this.setState({ data: arr, pending_changes: true });
                        } else {
                            console.error('drag&drop ignored');
                        }
                    }
                }
            }
        } catch (error) {
            console.error(error);
        }
    };

    handleAddElement = (parent, type) => {
        let title = 'form_field_edit_title';
        switch (type) {
            case types.tab:
                title = 'form_add_tab_title';
                break;
            case types.section:
                title = 'form_section_tab_title';
                break;
            default:
                title = 'form_field_tab_title';
                break;
        }
        this.setState({
            open: true,
            type: type,
            parent: parent,
            title: title,
            see: false
        });
    };

    handleClose = (e) => {
        this.setState({
            open: false,
            type: undefined,
            parent: undefined,
            selected: undefined,
        });
    };

    handleHide = (id, hide) => {
        const arr = [...this.state.data];
        let list = searchTree(arr, id);
        if (list) {
            list.hide = hide;
            this.setState({ data: arr });
        }
    };

    handleBack = () => {
        /*
            let path = this.props.history.location.pathname.split('/');
            path.splice(path.length - 1, 1);
            path = path.join('/');
            this.props.history.push(path);
        */
        if(this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }  
    };

    handleEdit = (element) => {
        let title = 'form_field_edit_title';
        switch (element.tipo) {
            case types.tab:
                title = 'form_edit_tab_title';
                break;
            case types.section:
                title = 'form_section_edit_title';
                break;
            default:
                title = 'form_field_edit_title';
                break;
        }
        this.setState({ open: true, type: element.tipo, title: title, selected: element, see: false});
    };

    handleSee = (element) => {
        let title = 'popup_partial_edit_menuitem';
        this.setState({ open: true, type: element.tipo, title: title, selected: element, see: true});
    };



    handleDelete = (toRemove) => {
        const arr = [...this.state.data];
        const parent = searchTree(arr, toRemove.padre);
        if (parent || toRemove.tipo === 'PESTANA') {
            const origin = parent ? parent.hijos : arr;
            const index = origin.indexOf(toRemove);
            origin.splice(index, 1);
            this.props.onModification(arr);
            this.setState({ data: arr, pending_changes: true });
        }
    };

    handleDuplicate = (element) => {

        const arr = [...this.state.data];
        const parent = searchTree(arr, element.padre);
        const list = parent ? parent.hijos : arr;
        const index = list.indexOf(element);
        if (index !== undefined) {
            const clone = changeCode(JSON.parse(JSON.stringify(element)), element.padre);
            clone.campoanterior = element.codigo;
            clone.nombre = clone.nombre + ' NEW';
            clone.status = 'NEW';
            list.splice(index + 1, 0, clone);
            this.props.onModification(arr);

            let title = 'form_field_edit_title';
            switch (element.tipo) {
                case types.tab:
                    title = 'form_edit_tab_title';
                    break;
                case types.section:
                    title = 'form_section_edit_title';
                    break;
                default:
                    title = 'form_field_edit_title';
                    break;
            }
            this.setState({ data: arr, pending_changes: true, open: true, type: element.tipo, title: title, selected: clone, see: false  });
        }
    };

    handleSummit = () => {
        this.setState({ pending_changes: false });
    };

    addElementField = (field) => {
        const arr = [...this.state.data];
        if (field.padre) {
            const container = searchTree(arr, field.padre);
            if (container) {
                const anterior = container.hijos.length === 0
                                        ? null
                                        : container.hijos[container.hijos.length - 1].codigo;
                field.campoanterior = anterior;
                container.hijos.push(field);
            }
        } else {
            const anterior = arr.length === 0 ? null : arr[arr.length - 1].codigo;
            field.campoanterior = anterior;
            arr.push(field);
        }
        this.props.onModification(arr);
        this.setState({
            data: arr,
            open: false,
            pending_changes: true,
        });
    };

    editElementField = (field) => {
        const arr = [...this.state.data];
        const container = searchTree(arr, field.padre);
        if (container) {
            if (field.entidad && !field.desactivable) {
                const desactivables = findElements(arr, field.codigo, 'desactivable');
                desactivables.map((d) => {
                    d.modified = true;
                    d.desactivable = false;
                    const temp = searchTree(arr, d.padre);
                    const i = temp.hijos.map((c) => c.codigo).indexOf(d.codigo);
                    temp.hijos.splice(i, 1, d);
                    return d;
                });
            }

            if (field.entidad && !field.obligatorio) {
                const obligatorios = findElements(arr, field.codigo, 'obligatorio');
                obligatorios.map((d) => {
                    d.modified = true;
                    d.obligatorio = false;
                    const temp = searchTree(arr, d.padre);
                    const i = temp.hijos.map((c) => c.codigo).indexOf(d.codigo);
                    temp.hijos.splice(i, 1, d);
                    return d;
                });
            }

            const index = container.hijos.map((c) => c.codigo).indexOf(field.codigo);
            container.hijos.splice(index, 1, field);
        } else {
            const index = arr.map((c) => c.codigo).indexOf(field.codigo);
            arr.splice(index, 1, field);
        }
        this.props.onModification(arr);
        this.setState({
            data: arr,
            open: false,
            selected: undefined,
            pending_changes: true,
        });
    };

    element = (e, parent) => {
        return (
            <Field
                {...this.props}
                programation={e.programacion}
                name={e.nombre}
                type={e.tipo}
                style={e.estilo}
                id={e.codigo}
                hide={e.hide ? e.hide : false}
                childs={e.hijos}
                modified={e.modified}
                element={e}
                sts={e.sts}
                typeId={this.props.typeId}
                onHide={this.handleHide.bind(this)}
                onEdit={this.handleEdit.bind(this)}
                onSee={this.handleSee.bind(this)}
                onDelete={this.handleDelete.bind(this)}
                onDuplicate={this.handleDuplicate.bind(this)}
            />
        );
    };

    subTree = (element, parent) => {
        return (
            <div id={element.codigo} key={randomstring()} className="bloc--first li">
                <div id={element.codigo} className={'bloc--inner '}>
                    {this.element(element, parent)}
                    {element &&
                        (element.tipo === 'PESTANA' || element.tipo === 'SECCION') &&
                        element.hijos &&
                        !element.hide && (
                            <div id={element.codigo} className={'bloc ul padding_borders_left'}>
                                {element.hijos &&
                                    !element.hide &&
                                    element.hijos.map((c) => this.subTree(c, element.codigo))}
                            </div>
                        )}
                    {!this.props.edit_rule && !this.props.selectedField && !this.props.selectedRule &&
                        !element.hide &&
                        element &&
                        (element.tipo === 'PESTANA' || element.tipo === 'SECCION') && (
                            <ButtonAdd
                                id={'form_field_tab'}
                                handleClick={() =>
                                    this.handleAddElement(element.codigo, types.boolean)
                                }
                            />
                        )}
                    {!this.props.edit_rule && !this.props.selectedField && !this.props.selectedRule &&
                        !element.hide &&
                        element &&
                        element.tipo === 'PESTANA' && (
                            <ButtonAdd
                                id={'form_section_tab'}
                                handleClick={() =>
                                    this.handleAddElement(element.codigo, types.section)
                                }
                            />
                        )}
                </div>
            </div>
        );
    };

    render() {
        const { data, open, type, title, selected, parent, see } = this.state;
        return (
            <div className="flex_full_column padding_top_12">
                <div className="flex_full_column ">
                    <div className="flex_full_row padding_left_36 overflow_y_scroll margin_bottom_32_movil">
                        <div className="container flex_grow_1 padding_borders_equals bg_ice_blue">
                            <div id={'root'} className={'bloc ul'}>
                                {data &&
                                    data.map((child) => (
                                        <div
                                            key={randomstring()}
                                            id={child.codigo}
                                            className="bloc--first li"
                                        >
                                            <div id={child.codigo} className="bloc--inner">
                                                {this.element(child, 'root')}
                                                {!child.hide && child.hijos && (
                                                    <div
                                                        key={randomstring()}
                                                        id={child.codigo}
                                                        className={
                                                            'bloc ul padding_borders_left margin_bottom_5'
                                                        }
                                                    >
                                                        {!child.hide &&
                                                            child.hijos &&
                                                            child.hijos.map((c) =>
                                                                this.subTree(c, child.codigo),
                                                            )}
                                                    </div>
                                                )}
                                                {!this.props.edit_rule && !this.props.selectedField && !this.props.selectedRule &&
                                                    !child.hide &&
                                                    child &&
                                                    (child.tipo === 'PESTANA' ||
                                                        child.tipo === 'SECCION') && (
                                                        <ButtonAdd
                                                            id={'form_field_tab'}
                                                            handleClick={() =>
                                                                this.handleAddElement(
                                                                    child.codigo,
                                                                    types.boolean,
                                                                )
                                                            }
                                                        />
                                                    )}
                                                {!this.props.edit_rule && !this.props.selectedField && !this.props.selectedRule &&
                                                    !child.hide &&
                                                    child &&
                                                    child.tipo === 'PESTANA' && (
                                                        <ButtonAdd
                                                            id={'form_section_tab'}
                                                            handleClick={() =>
                                                                this.handleAddElement(
                                                                    child.codigo,
                                                                    types.section,
                                                                )
                                                            }
                                                        />
                                                    )}
                                            </div>
                                        </div>
                                    ))}
                            </div>
                            <div className="flex_auto_row">
                                {!this.props.edit_rule && !this.props.selectedField && !this.props.selectedRule && (
                                    <ButtonAdd
                                        id={'form_add_tab'}
                                        handleClick={() =>
                                            this.handleAddElement(undefined, types.tab)
                                        }
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                {open && (
                    <Add
                        {...this.props}
                        data={data}
                        title={title}
                        parentID={selected ? selected.padre : parent}
                        parentObject={searchTree(data, selected ? selected.padre : parent)}
                        open={open}
                        element={selected}
                        type={type}
                        see={see}
                        onClose={() => this.handleClose()}
                        add={this.addElementField}
                        edit={this.editElementField}
                    />
                )}
            </div>
        );
    }
}

export default Fields;



// WEBPACK FOOTER //
// ./src/components/complex/manage/checks/Fields.js